import { t } from "@/i18n"
import { onlyfyFullTheme, xingTheme } from "@xingternal/rebranding-adapter"

const product = {
  ebp: "360_RECRUITER_INSIGHTS_EBP",
  xjm: "360_RECRUITER_INSIGHTS_XJM",
  xtm: "360_RECRUITER_INSIGHTS_XTM",
  xtp: "360_RECRUITER_INSIGHTS_XTP",
  xbm: "360_RECRUITER_INSIGHTS_XBM",
  360: "360_RECRUITER_INSIGHTS_360",
}

const products = {
  ebp: (enableXingRebranding) => ({
    color: enableXingRebranding ? "#D4699E" : onlyfyFullTheme.colors.xbm,
    icon: "ebp",
    title: `${t(product.ebp)}`,
    license: t(product.ebp),
  }),
  xjm: (enableXingRebranding) => ({
    color: enableXingRebranding
      ? xingTheme.colors.xingPetrol2
      : onlyfyFullTheme.colors.xjm,
    icon: "xjm",
    title: `${t(product.xjm)}`,
    license: t(product.xjm),
    url: "/jobmanager/online?sc_o=xri_app_switcher_to_xjm_click",
  }),
  xtm: (enableXingRebranding) => ({
    color: enableXingRebranding
      ? xingTheme.colors.mint
      : onlyfyFullTheme.colors.xtm,
    icon: "xtm",
    title: `${t(product.xtm)}`,
    license: t(product.xtm),
    url: "/xtm?sc_o=xri_app_switcher_to_xtm_click",
  }),
  xtp: (enableXingRebranding) => ({
    color: enableXingRebranding
      ? xingTheme.colors.xingLime2
      : onlyfyFullTheme.colors.xtp,
    icon: "xtp",
    title: `${t(product.xtp)}`,
    license: t(product.xtp),
    url: "/xtm/pools/automatic?sc_o=xri_app_switcher_to_xtp_click",
  }),
  xbm: (enableXingRebranding) => ({
    color: enableXingRebranding ? "#D4699E" : onlyfyFullTheme.colors.xbm,
    icon: "xbm",
    title: `${t(product.xbm)}`,
    license: t(product.xbm),
    url: "/brandmanager?sc_o=xri_app_switcher_to_xbm_click",
  }),
  360: () => ({
    color: onlyfyFullTheme.colors[360],
    icon: "360",
    title: t(product["360"]),
    license: t(product["360"]),
  }),
}

const getProduct = (product, enableXingRebranding) => {
  const resolvedProduct = products[product] || products.xtm

  return resolvedProduct(enableXingRebranding)
}

export default products
export { getProduct }
